__turbopack_context__.v({
  "badge": "UnidadPendingBadge-module__lyCCaW__badge",
  "tooltip": "UnidadPendingBadge-module__lyCCaW__tooltip",
});
